import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "UiSuspense__in" }
const _hoisted_2 = { class: "UiSuspense__icon" }
const _hoisted_3 = {
  key: 0,
  class: "UiSuspense__content"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "UiSuspense__description" }, " Загружаем данные с сервера, пожалуйста подождите... ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "UiSuspense__in UiSuspense__in--failure" }
const _hoisted_7 = { class: "UiSuspense__icon" }
const _hoisted_8 = {
  key: 0,
  class: "UiSuspense__content"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "UiSuspense__description" }, " Произошла ошибка при загрузке данных с сервера. Попробуйте позже. ", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Попробовать еще раз ")

import "./UiSuspense.css";

import { computed, PropType } from "vue";

import UiLoader from "../loader/UiLoader.vue";
import UiIcon from "../icon/UiIcon.vue";
import UiBtn from "../button/UiBtn.vue";

type Variant = "default" | "screen" | "compact";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiSuspense',
  props: {
  pending: { type: Boolean, default: false },
  failure: { type: Boolean, default: false },
  success: { type: Boolean, default: false },
  hasRetry: { type: Boolean, default: false },
  variant: { type: String as PropType<Variant>, default: "default" },
},
  emits: ["retry"],
  setup(__props, { emit }) {

const props = __props




const rootClasses = computed(() => ({
  UiSuspense: true,
  [`UiSuspense--${props.variant}`]: props.variant,
}));

return (_ctx: any,_cache: any) => {
  return (__props.success)
    ? _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)))
    : (__props.pending)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_unref(rootClasses))
        }, [
          _renderSlot(_ctx.$slots, "pending", {}, () => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(UiLoader, {
                  size: __props.variant === 'screen' ? 32 : 24
                }, null, 8, ["size"])
              ]),
              (__props.variant !== 'compact')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      : (__props.failure)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(_unref(rootClasses))
          }, [
            _renderSlot(_ctx.$slots, "failure", {}, () => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(UiIcon, {
                    size: __props.variant === 'screen' ? 32 : 24,
                    icon: "X"
                  }, null, 8, ["size"])
                ]),
                (__props.variant !== 'compact')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      (__props.hasRetry)
                        ? (_openBlock(), _createBlock(UiBtn, {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry'))),
                            size: __props.variant === 'screen' ? 'md' : 'sm',
                            variant: "destructive"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }, 8, ["size"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(_unref(rootClasses))
          }, [
            _renderSlot(_ctx.$slots, "unknown")
          ], 2))
}
}

})